import Button from '../../../../../components/button/Button';
import Modal from '../../../../../components/modal/Modal';
import helpIcon from '../../../../../assets/helpIcon.svg';
import pin from '../../../../../assets/pin_drop.svg';

import powerIconSwitch from '../../../../../assets/switch-button-power-icon.png';

import carIcon from '../../../../../assets/car-icon.png';
import autonomyIcon from '../../../../../assets/autonomy-icon.png';
import plateIcon from '../../../../../assets/plate-icon.png';
import socketIcon from '../../../../../assets/socket-icon.png';

import { TableViewerComponent } from '../Table';
import ToastMapsOptions from '../../../../../components/toastMapsOptions/ToastMapsOptions';
import ToastHelp from '../../../../../components/toastHelp/ToastHelp';
import { useToastStore } from '../../../../../hooks/useToastStore';

interface ModalCarInfoProps {
  isModalOpen: boolean;
  setIsModalOpen: (isOpen: boolean) => void;
  brandColor: string;
  info: any;
}

export const ModalCarInfoComponent = ({
  isModalOpen,
  setIsModalOpen,
  brandColor,
  info,
}: ModalCarInfoProps) => {
  const { uvTelemetryLocation = {} } = info;
  const { coordinates = [0, 0] } = uvTelemetryLocation;
  const mapUrl = `https://www.google.com/maps/search/?api=1&query=${coordinates[1]},${coordinates[0]}`;
  const appleURl = `http://maps.apple.com/?q=${coordinates[1]},${coordinates[0]}`;
  const wazeUrl = `https://waze.com/ul?ll=${coordinates[1]},${coordinates[0]}&navigate=yes`;

  const {
    showDirectionsToast,
    showHelpToast,
    setShowHelpToast,
    setShowDirectionsToast,
  } = useToastStore();

  return (
    <>
      <Modal
        allowButtonClosed={false}
        isOpen={isModalOpen}
        onClose={() => {
          setIsModalOpen(false);
        }}
        isLoadingEnterButton={false}
        styleEnterButton={{ backgroundColor: brandColor }}
        disableEnterButton={false}
        modalBackdrop={false}
        header={false}
      >
        <TableViewerComponent
          data={[info]}
          extraColumn={[
            {
              name: 'autonomy',
              label: 'Site mais próximo',
              align: 'left',
              icon: socketIcon,
              render: (dataColumn: any) => {
                return (
                  <div
                    className=''
                    style={{
                      background: '#e0ece9',

                      lineHeight: '35px',
                      padding: '0px 10px',
                      width: '100%',
                    }}
                  >
                    <div
                      className='vp-power-kW'
                      style={{
                        fontSize: 12,
                        lineHeight: 1.2,
                        height: 35,
                        display: 'flex',
                        alignItems: 'center',
                        textAlign: 'left',
                      }}
                    >
                      Site mais próximo
                    </div>
                  </div>
                );
              },
            },
            {
              name: 'autonomy',
              label: 'Site mais próximo',
              colspan: 2,
              align: 'left',
              icon: socketIcon,
              render: (dataColumn: any) => {
                return dataColumn.nearestSiteName ? (
                  <div
                    style={{
                      padding: '0x 10px',
                      background: '#F9FAF8',
                      paddingLeft: 10,
                      width: '100%',
                    }}
                  >
                    <div
                      className='vp-power-kW'
                      style={{
                        fontSize: 12,
                        lineHeight: 1.2,
                        height: 35,
                        display: 'flex',
                        alignItems: 'center',
                        textAlign: 'left',
                      }}
                    >
                      {dataColumn.nearestSiteName
                        ? dataColumn.nearestSiteName
                        : '-'}
                    </div>
                  </div>
                ) : (
                  '-'
                );
              },
            },
          ]}
          columns={[
            {
              name: 'vehicle',
              label: 'Veículo',
              align: 'left',
              icon: carIcon,
              render: (dataColumn: any) => {
                return (
                  <div className='vp-charger-info'>
                    <span className='vp-charger-name'>{dataColumn.uvName}</span>
                    <span className='vp-cp-code'>
                      Bateria:{' '}
                      {dataColumn.uvTelemetrySoc === null
                        ? '-'
                        : `${dataColumn?.uvTelemetrySoc?.toFixed(0)}%`}
                      {dataColumn.isCharging ? (
                        <img
                          src={powerIconSwitch}
                          alt={`${powerIconSwitch}`}
                          className='cs-table-icon'
                        />
                      ) : (
                        ''
                      )}
                    </span>
                  </div>
                );
              },
            },
            {
              name: 'autonomy',
              label: 'Autonomia',
              align: 'center',
              icon: autonomyIcon,
              render: (dataColumn: any) => {
                return (
                  dataColumn.autonomyKm && (
                    <div className='vp-power-info'>
                      <span className='vp-power-kWh'>
                        {dataColumn.autonomyKm} Km
                      </span>
                      <span className='vp-power-kW'>
                        {dataColumn.uvTelemetryBatteryKwh
                          ? dataColumn.uvTelemetryBatteryKwh
                          : '-'}{' '}
                        kWh
                      </span>
                    </div>
                  )
                );
              },
            },
            {
              name: 'plate',
              label: 'Placa',
              align: 'center',
              icon: plateIcon,
              render: (dataColumn: any) => {
                return (
                  <div className='vp-charger-status-container'>
                    <div
                      className='vp-chager-status-wrapper'
                      style={{
                        backgroundColor:
                          dataColumn.uvTelemetrySoc < 45
                            ? '#EF6D44'
                            : dataColumn.uvTelemetrySoc >= 45 &&
                              dataColumn.uvTelemetrySoc < 65
                            ? '#FDE047'
                            : '#93E22E',
                        color:
                          dataColumn.uvTelemetrySoc < 45
                            ? '#FFFFFF'
                            : dataColumn.uvTelemetrySoc >= 45 &&
                              dataColumn.uvTelemetrySoc < 65
                            ? '#713F12'
                            : '#196912',
                      }}
                    >
                      <span>{dataColumn.uvLicencePlate}</span>
                    </div>
                  </div>
                );
              },
            },
          ]}
        />
        {/* Ações */}
        <div className='actions-container' style={{ marginBottom: '5px' }}>
          <Button
            className='btn-outline-md'
            type='button'
            children='Como Chegar'
            spinnerSecondary={true}
            onClick={() => setShowDirectionsToast(true)}
            image={<img src={pin} alt='Como Chegar' />}
            style={{ fontSize: 15 }}
          />

          <Button
            className='btn-outline-md'
            type='button'
            children='Ajuda'
            spinnerSecondary={true}
            onClick={() => setShowHelpToast(true)}
            image={<img src={helpIcon} alt='Ajuda' />}
            style={{ fontSize: 15 }}
          />
        </div>
      </Modal>
      <ToastMapsOptions
        googleMapsUrl={mapUrl}
        appleMapsUrl={appleURl}
        wazeUrl={wazeUrl}
        isModalOpen={showDirectionsToast}
        allowButtonClosed={true}
        setShowToastMapsOptions={setShowDirectionsToast}
      />
      <ToastHelp
        isModalOpen={showHelpToast}
        allowButtonClosed={true}
        setShowHelpToast={setShowHelpToast}
      />
    </>
  );
};
